<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2">Abbreviations</h1>
<p class="para">Only abbreviations not currently found in the <em>SBL Handbook of Style</em> are included here.</p>
<table class="table1">
<tbody>
<tr>
<td class="width1">
<p class="t-left"><em>Arab. Arch. Epig.</em></p></td>
<td class="width2">
<p class="t-left"><em>Arabian Archaeology and Epigraphy</em></p></td>
</tr>
<tr>
<td>
<p class="t-left">AUSDDS</p></td>
<td>
<p class="t-left">Andrews University Seminary Doctoral Dissertation Series</p></td>
</tr>
<tr>
<td>
<p class="t-left"><span class="smallcaps">CSB</span></p></td>
<td>
<p class="t-left">Christian Standard Bible</p></td>
</tr>
<tr>
<td>
<p class="t-left"><em>EAnth</em></p></td>
<td>
<p class="t-left"><em>Encyclopedia of Anthropology</em>. 5 vols. Ed. H. James Birx. Thousand Oaks, CA: Sage, 2006.</p></td>
</tr>
<tr>
<td>
<p class="t-left">ECNT</p></td>
<td>
<p class="t-left">Exegetical Commentary on the New Testament</p></td>
</tr>
<tr>
<td>
<p class="t-left">ETS</p></td>
<td>
<p class="t-left">Evangelical Theological Society</p></td>
</tr>
<tr>
<td>
<p class="t-left"><span class="smallcaps">EXB</span></p></td>
<td>
<p class="t-left">Expanded Bible</p></td>
</tr>
<tr>
<td>
<p class="t-left"><span class="smallcaps">GW</span></p></td>
<td>
<p class="t-left">GOD’S WORD Translation</p></td>
</tr>
<tr>
<td>
<p class="t-left"><span class="smallcaps">ISV</span></p></td>
<td>
<p class="t-left">International Standard Version</p></td>
</tr>
<tr>
<td>
<p class="t-left">KEL</p></td>
<td>
<p class="t-left">Kregel Exegetical Library</p></td>
</tr>
<tr>
<td>
<p class="t-left"><span class="smallcaps">LEB</span></p></td>
<td>
<p class="t-left">Lexham English Bible</p></td>
</tr>
<tr>
<td>
<p class="t-left">LGRB</p></td>
<td>
<p class="t-left">Lives of Great Religious Books</p></td>
</tr>
<tr>
<td>
<p class="t-left">MBI</p></td>
<td>
<p class="t-left">Methods in Biblical Interpretation</p></td>
</tr>
<tr>
<td>
<p class="t-left"><span class="smallcaps">NCV</span></p></td>
<td>
<p class="t-left">New Century Version</p></td>
</tr>
<tr>
<td>
<p class="t-left"><em>NEASB</em></p></td>
<td>
<p class="t-left"><em>Near East Archaeology Society Bulletin</em></p></td>
</tr>
<tr>
<td>
<p class="t-left"><span class="smallcaps">NOG</span></p></td>
<td>
<p class="t-left">Names of God Bible</p></td>
</tr>
<tr>
<td>
<p class="t-left"><em>OEBI</em></p></td>
<td>
<p class="t-left"><em>The Oxford Encyclopedia of Biblical Interpretation.</em> Ed. Steven L. McKenzie. Oxford: Oxford University Press, 2013.</p></td>
</tr>
<tr>
<td>
<p class="t-left">PHSC</p></td>
<td>
<p class="t-left">Perspectives on Hebrew Scriptures and Its Contexts</p></td>
</tr>
<tr>
<td>
<p class="t-left">SBEC</p></td>
<td>
<p class="t-left">Studies in the Bible and Early Christianity</p></td>
</tr>
<tr>
<td>
<p class="t-left">SRA</p></td>
<td>
<p class="t-left">Studies in Religion and the Arts</p></td>
</tr>
<tr>
<td>
<p class="t-left">TatC</p></td>
<td>
<p class="t-left">Texts @ Contexts</p></td>
</tr>
<tr>
<td>
<p class="t-left"><span class="smallcaps">YLT</span></p></td>
<td>
<p class="t-left">Young’s Literal Translation</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Abbreviations.vue?1e56770b